import { userApiSwrRefetchMiniCart } from '../../user-data'
import { handleAddToCartErrorApm } from '../api/addToCartErrorApmLogger'
import {
  type CartIntermediateMultipleProductsAddToCartProps,
  useCartIntermediateApiSwrMultipleProductsAddToCartMutation,
} from '../api/swr/useCartIntermediateApiSwrMultipleProductsAddToCartMutation'
import { updateIsDataSuccessfullyAddedToCartFromResponse } from '../helpers/updateIsDataSuccessfullyAddedToCartFromResponse'
import { cartIntermediateAccessorGetDrawerMessages } from '../model/cartIntermediateMutationResponseDataAccessor'

import { useCartIntermediateContext } from './useCartIntermediateContext'

export const useMultipleProductsAddToCart = ({
  currentPrescriptionType,
  products,
}: CartIntermediateMultipleProductsAddToCartProps): {
  handleAddToCart: () => Promise<void>
} => {
  const productAddToCartMutation =
    useCartIntermediateApiSwrMultipleProductsAddToCartMutation({
      currentPrescriptionType,
      products,
    })
  const {
    openCartIntermediateDrawerWithData,
    resetCartIntermediateContext,
    setIsDataSuccessfullyAddedToCart,
  } = useCartIntermediateContext()

  const handleAddToCart = async (): Promise<void> => {
    resetCartIntermediateContext()
    try {
      await productAddToCartMutation.trigger()
      await userApiSwrRefetchMiniCart()
    } catch (error) {
      handleAddToCartErrorApm(error)
    } finally {
      const response = productAddToCartMutation.data ?? null
      const drawerMessages = cartIntermediateAccessorGetDrawerMessages(response)
      updateIsDataSuccessfullyAddedToCartFromResponse(
        response,
        setIsDataSuccessfullyAddedToCart,
      )
      openCartIntermediateDrawerWithData(products, drawerMessages)
    }
  }

  return {
    handleAddToCart,
  }
}
